import type { QueryClient } from '@tanstack/react-query';
import type { QueryKeyData } from './query-options';

export const getQueryDataFromKey = <TEntry extends QueryKeyData<unknown>>(
  queryClient: QueryClient,
  queryKey: TEntry['key'],
): TEntry['data'] | undefined => queryClient.getQueryData<TEntry['data']>(queryKey);
